const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '');

const browserHost =
  typeof window !== 'undefined' ? window.location.hostname : '';
const isLocal = browserHost === 'localhost' || browserHost === '127.0.0.1';

const baseUrl = trimTrailingSlash(
  process.env.REACT_APP_API_BASE_URL ||
    (isLocal
      ? 'http://127.0.0.1:8000'
      : 'https://sale-radius-bab0d241ed92.herokuapp.com'),
);

export default baseUrl;

export const META_APP_ID =
  process.env.REACT_APP_META_APP_ID || '841689861857500';
